import { createApp, h, nextTick, onBeforeUnmount, Teleport } from 'vue';
import AuthComponent from '@components/loginModal.vue';

export default {
  install(app) {
    let authInstance = null;
    let container = null;

    const mountAuthComponent = async () => {
      if (!container) {
        container = document.createElement('div');
        container.id = 'auth-component';
        document.body.appendChild(container);

        const comp = createApp(AuthComponent)
        authInstance = comp.mount(container);
      }
    };


    app.config.globalProperties.$showLogin = async function () {
      console.log('showLogin')
      if (!authInstance) {
        await mountAuthComponent();
      }

      if (authInstance && typeof authInstance.show === 'function') {
        authInstance.show();
      }
    };
    app.config.globalProperties.$closeLogin = async function () {
      if (authInstance && authInstance.proxy && typeof authInstance.proxy.close === 'function') {
        await nextTick(); 
        authInstance.proxy.close();
      }
    };


    app.config.globalProperties.$destroyLogin = function () {
      if (authInstance && container) {
        if (authInstance.unmount) {
          authInstance.unmount();
        }
        document.body.removeChild(container);
        authInstance = null;
        container = null;
      }
    };

    app.provide('auth', {
      showLogin: app.config.globalProperties.$showLogin,
      closeLogin: app.config.globalProperties.$closeLogin,
      destroyLogin: app.config.globalProperties.$destroyLogin,
    });


    onBeforeUnmount(() => {
      app.config.globalProperties.$destroyLogin();
    });
  },
};